/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Voucher_InvalidInputs */

const en_voucher_invalid = /** @type {(inputs: Voucher_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That code isn't valid.`)
};

const id_voucher_invalid = /** @type {(inputs: Voucher_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kode itu tidak valid.`)
};

/**
* | output |
* | --- |
* | "That code isn't valid." |
*
* @param {Voucher_InvalidInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const voucher_invalid = /** @type {((inputs?: Voucher_InvalidInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voucher_InvalidInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_voucher_invalid(inputs)
	return en_voucher_invalid(inputs)
});